


































































































import { Component, Prop } from 'vue-property-decorator'

import { RowButtonView } from '../../../../../../components'
import SampleNodeMixin from '../../../../SampleNodeMixin'
import { ActionNode } from '../../logic/ActionNode'
import { KickActionProxy } from '../../logic/Actions/KickAction/KickActionProxy'
import { LabelsActionProxy } from '../../logic/Actions/LabelsAction/LabelsActionProxy'
import { NotifyGroupActionProxy } from '../../logic/Actions/NotifyGroupAction/NotifyGroupActionProxy'
import { NotifyUsersActionProxy } from '../../logic/Actions/NotifyUsersAction/NotifyUsersActionProxy'
import { PropertyActionProxy } from '../../logic/Actions/PropertyAction/PropertyActionProxy'
import { RemovePropertiesProxy } from '../../logic/Actions/RemoveProperties/RemovePropertiesProxy'
import KickActionNode from './components/KickActionNode.vue'
import LabelsAction from './components/LabelAction.vue'
import NotifyGroupAction from './components/NotifyGroupAction.vue'
import NotifyUsersAction from './components/NotifyUsersAction.vue'
import PropertyAction from './components/PropertyAction.vue'
import RemovePropertiesActionNode from './components/RemovePropertiesActionNode.vue'

@Component({
  components: {
    KickActionNode,
    RemovePropertiesActionNode,
    RowButtonView,
    LabelsAction,
    PropertyAction,
    NotifyUsersAction,
    NotifyGroupAction,
  },
  data() {
    return {
      KickActionProxy,
      LabelsActionProxy,
      PropertyActionProxy,
      NotifyGroupActionProxy,
      NotifyUsersActionProxy,
      RemovePropertiesProxy
    }
  }
})
export default class ActionNodeSidebar extends SampleNodeMixin {
  @Prop() node!: ActionNode
}
